import React from "react";
import styled from "styled-components";
import { EyeOff16Regular } from "@fluentui/react-icons";
import { useTip } from "../Tooltip/Tooltip";
import { useTooltipStore } from "../../../store/useTooltipStore";
import useIndicatorsVisibility from "../../../hooks/useIndicatorsVisibility";

/** Classe utilisée par Card pour révéler le bouton au survol */
export const HIDE_BUTTON_CLASS = "prh-hide-btn";

/** Œil en haut à droite d'une carte : masque l'indicateur (avec "Annuler") */
const HideButton = ({ indicator, label }) => {
    const tip = useTip();
    const hideTip = useTooltipStore((s) => s.hide);
    const { hideWithUndo } = useIndicatorsVisibility();

    const onClick = () => {
        hideTip();
        hideWithUndo(indicator, label);
    };

    return (
        <Button
            type="button"
            className={HIDE_BUTTON_CLASS}
            aria-label={`Masquer ${label}`}
            onClick={onClick}
            {...tip("Masquer cet indicateur")}
        >
            <EyeOff16Regular />
        </Button>
    );
};

export default HideButton;

const Button = styled.button`
    position: absolute;
    top: 11px;
    right: 11px;
    width: 26px;
    height: 26px;
    padding: 0;
    border-radius: 6px;
    border: 1px solid transparent;
    background: var(--prh-card);
    color: var(--prh-muted-2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.12s, background 0.12s, color 0.12s;

    &:hover {
        background: var(--prh-violet-bg);
        color: var(--prh-violet-dark);
        border-color: var(--prh-violet-line);
    }
    &:focus-visible {
        opacity: 1;
        outline: 2px solid var(--prh-violet);
    }
`;
